import socket from 'widgets/lib/socket';
import { handleGamesFightSocket } from '@/modules/widgets/functions/games-fight';

import room from './room';
// import sofa from '../../components/sofa/main'
// import group from '../../components/group-info/main'
// import recommend from '../../components/live-recommend/main'
// import fans from '../../components/fans/main'
import joinLine from './join-line';
import heartbeatPk from './heartbeat-pk';
import racePk from './race-pk';
import maskPk from './mask-pk';
import adminList from '../admin-list';
import oath from '../../func/oath/socket';

let { socketEvent } = socket;

const init = () => {
  // sofa.addSocketHandle(socketEvent)
  // group.addSocketHandle(socketEvent)
  // recommend.addSocketHandle(socketEvent)
  // fans.addSocketHandle(socketEvent)

  room(socketEvent);
  joinLine(socketEvent);
  heartbeatPk(socketEvent);
  racePk(socketEvent);
  maskPk(socketEvent);
  oath(socketEvent);
  adminList.initSocket(socketEvent);
  handleGamesFightSocket(socketEvent);
};

export { socketEvent };

export default {
  init,
};
